import {
    HttpResponse,
    ScrapCauseModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ScrapCausesDataService implements CrudService<ScrapCauseModel, ScrapCauseModel> {
    getAll(query: CrudDataQuery<ScrapCauseModel>): Promise<CrudEnumerableResponse<ScrapCauseModel>> {
        return ApiService.api.getScrapCauseBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ScrapCauseModel>): Promise<CrudEnumerableResponse<ScrapCauseModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ScrapCauseModel>> {
        return ApiService.api.getScrapCauseById(id, params);
    }

    create(item: ScrapCauseModel, params?: RequestParams): Promise<CrudResponse<ScrapCauseModel>> {
        return ApiService.api.insertScrapCause(item, params);
    }

    update(item: ScrapCauseModel, params?: RequestParams): Promise<ScrapCauseModel> {
        return ApiService.api.updateScrapCause(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ScrapCauseModel> {
        return ApiService.api.patchScrapCause(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ScrapCauseModel>): Promise<CrudEnumerableResponse<ScrapCauseModel>> {
        return ApiService.api.deleteScrapCauses(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationScrapCause(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ScrapCauseModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ScrapCauseModel, params?: RequestParams): Promise<CrudResponse<ScrapCauseModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getScrapCauseGroupped(query, params);
    }

}
